import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';

import { LOGIN_PAGE_URL} from '../constants/systemConstants';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <LoadingSpinner 
        fullPage 
        size={40}
        text="Loading..."
      />
    );
  }
  
  if (!currentUser) {
    return <Navigate to={LOGIN_PAGE_URL} state={{ from: location }} replace />;
  }
  
  return children;
};

export default ProtectedRoute;